<div *ngIf="processing == true">
  <app-paymentprocess></app-paymentprocess>
</div>
<div *ngIf="view_payment == false && final_result == false && processing == false">
  <!-- <form accept-charset="UTF-8" #membershipform="ngForm" (submit)="formChecker()"> -->
  <div class="ui-g-12">
    <div class="card no-margin">
      <p-fieldset [style]="{ border: '1px solid #000000' }">
        <p-header><b>Select a Membership type</b></p-header>
        <div class="ui-g">
          <ng-container *ngIf="!selfActivated">
            <div class="ui-g-12 ui-md-4">
              <p-radioButton name="rg" [value]="false" label="Membership for you" [(ngModel)]="agree"
                (click)="UserDetails()" [disabled]="
                  choice_selection_disabled || this.api_result.Posting
                ">
              </p-radioButton>
            </div>
          </ng-container>
          <div class="ui-g-12 ui-md-4">
            <p-radioButton name="rg" [value]="true" label="Membership for others" [(ngModel)]="agree"
              (click)="UserDetails()" [disabled]="choice_selection_disabled || this.api_result.Posting" first>
            </p-radioButton>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>

  <ng-container *ngIf="optionSelect">
    <form accept-charset="UTF-8" #membershipform="ngForm" (submit)="formChecker()">
      <div class="ui-g-12">
        <div class="card no-margin">
          <p-fieldset [style]="{ border: '1px solid #000000' }">
            <p-header><b>Personal Information</b></p-header>
            <div class="ui-g">
              <div class="ui-g form-group">
                <div class="ui-g-12 ui-lg-6">
                  <ng-container *ngIf="agree">
                    <div class="ui-g-12 ui-md-4">
                      <label for="relation">Relationship<span class="req">*</span></label>
                    </div>
                    <div class="ui-g-12 ui-md-8">
                      <p-dropdown id="relation" [options]="relations" [(ngModel)]="selectedRelation" optionLabel="name"
                        placeholder="Select" [style]="{ width: '260px' }" name="relationship" #relationship="ngModel"
                        required (onChange)="dirty()"></p-dropdown>
                      <div class="invalid" *ngIf="this.membershipFormChecker.relation == false">
                        Relationship is required.
                      </div>
                      <div *ngIf="this.membershipFormChecker.relation == true">
                        <div *ngIf="
                            relationship.invalid &&
                            (relationship.dirty || relationship.touched)
                          " class="alert alert-danger">
                          <div *ngIf="relationship.errors.required" class="invalid">
                            Relationship is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="ui-g-12 ui-md-4">
                    <label for="firstname">First Name<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="firstname" type="text" pInputText [pKeyFilter]="name_input" style="
                        width: 260px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " [disabled]="!agree" name="first_name" [(ngModel)]="this.patient.first_name"
                      #firstname="ngModel" required class="form-check-input" />
                    <div class="invalid" *ngIf="this.membershipFormChecker.first_name == false">
                      First name is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.first_name == true">
                      <div *ngIf="
                          firstname.invalid &&
                          (firstname.dirty || firstname.touched)
                        " class="alert alert-danger">
                        <div *ngIf="firstname.errors.required" class="invalid">
                          First name is required.
                        </div>
                        <div *ngIf="firstname.errors.FieldValidator" class="invalid">
                          Invalid First name.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="middlename">Middle Name</label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="middlename" type="text" pInputText [pKeyFilter]="name_input"
                      style="width: 260px; color: black; opacity: inherit" [disabled]="!agree"
                      [(ngModel)]="this.patient.middle_name" name="middlename" #middlename="ngModel"
                      class="form-check-input" />
                    <div *ngIf="
                        middlename.invalid &&
                        (middlename.dirty || middlename.touched)
                      " class="alert alert-danger">
                      <div *ngIf="middlename.errors.FieldValidator" class="invalid">
                        Invalid Middle name.
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="lastname">Last Name<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="lastname" type="text" pInputText [pKeyFilter]="name_input" style="
                        width: 260px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " [disabled]="!agree" name="lastname" [(ngModel)]="this.patient.last_name" #lastname="ngModel"
                      required class="form-check-input" />
                    <div class="invalid" *ngIf="this.membershipFormChecker.last_name == false">
                      Last name is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.last_name == true">
                      <div *ngIf="
                          lastname.invalid &&
                          (lastname.dirty || lastname.touched)
                        " class="alert alert-danger">
                        <div *ngIf="lastname.errors.required" class="invalid">
                          Last name is required.
                        </div>
                        <div *ngIf="lastname.errors.FieldValidator" class="invalid">
                          Invalid Last name.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="dob">Date Of Birth<span class="req">*</span></label>
                  </div>
                  <ng-container *ngIf="agree">
                    <div class="ui-g-12 ui-md-8">
                      <p-calendar id="dob" class="notranslate" [defaultDate]="max_date" [maxDate]="max_date"
                        FieldValidator="Dob" dateFormat="dd/mm/yy" [monthNavigator]="true" [disabled]="!agree"
                        [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" placeholder="dd/mm/yyyy"
                        [(ngModel)]="this.patient_date_of_birth" name="date_of_birth" #date_of_birth="ngModel"
                        required></p-calendar>
                      <div class="invalid" *ngIf="
                          this.membershipFormChecker.date_of_birth == false
                        ">
                        Date of Birth is required.
                      </div>
                      <div *ngIf="this.membershipFormChecker.date_of_birth == true">
                        <div *ngIf="
                            date_of_birth.invalid &&
                            (date_of_birth.dirty || date_of_birth.touched)
                          " style="color: red" class="alert alert-danger">
                          <div *ngIf="date_of_birth.errors.required">
                            Date of Birth is required.
                          </div>
                        </div>
                      </div>
                      <div *ngIf="date_of_birth.errors.FieldValidator">
                        Invalid Date Of Birth. User must be at least 18.
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!agree">
                    <div class="ui-g-12 ui-md-8">
                      <input id="dob" type="text" pInputText style="width: 260px; color: black; opacity: inherit"
                        [disabled]="!agree" [(ngModel)]="dateBirth" name="date_of_birth" #date_of_birth="ngModel"
                        class="form-check-input" />
                    </div>
                  </ng-container>

                  <div class="ui-g-12 ui-md-4">
                    <label for="unid">Unique Identification</label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <p-dropdown id="unid" [options]="this.unique_id" [(ngModel)]="this.patient.identification_type"
                      placeholder="Select" [style]="{ width: '260px' }" name="unique_id_name" #unique_id_name="ngModel"
                      (onChange)="dirty()"></p-dropdown>
                  </div>
                  <div class="ui-g-12">
                    <p-fileUpload name="unique_id_file" (onSelect)="uploadUniqueIDFiles($event.files)"
                      [showUploadButton]="false" styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165"
                      (onRemove)="resetUnquieIDUpload()" [showCancelButton]="false" multiple="false" [fileLimit]="1"
                      accept="image/*">
                    </p-fileUpload>

                    <div class="alert alert-danger" role="alert">
                      <p class="text-center text-gray-underline">
                        <span class="font-weight-bold">Note</span>: The file
                        type supported for Unique Identification are
                        JPEG,JPG,PNG.
                      </p>
                    </div>
                  </div>

                  <p-fieldset [style]="{ width: '100%' }">
                    <p-header><b>Gender</b><span class="req">*</span></p-header>
                    <div class="ui-g">
                      <div class="ui-g-12 ui-lg-4">
                        <p-radioButton name="gender" value="male" label="Male" [(ngModel)]="this.patient.gender"
                          name="gender" #gender="ngModel" required></p-radioButton>
                      </div>
                      <div class="ui-g-12 ui-lg-4">
                        <p-radioButton name="gender" value="female" label="Female" [(ngModel)]="this.patient.gender"
                          name="gender" #gender="ngModel" required></p-radioButton>
                      </div>
                      <div class="ui-g-12 ui-lg-4">
                        <p-radioButton name="gender" value="other" label="Other" [(ngModel)]="this.patient.gender"
                          name="gender" #gender="ngModel" required></p-radioButton>
                      </div>
                      <div class="invalid" *ngIf="this.membershipFormChecker.gender == false">
                        Gender is required.
                      </div>
                      <div *ngIf="this.membershipFormChecker.gender == true">
                        <div *ngIf="
                            gender.invalid && (gender.dirty || gender.touched)
                          " class="alert alert-danger">
                          <div *ngIf="gender.errors.required" class="invalid">
                            Gender is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
                <div class="ui-g-12 ui-lg-6">
                  <div class="ui-g-12 ui-md-4">
                    <label for="add1">Address 1<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="add1" type="text" pInputText [pKeyFilter]="address"
                      style="width: 260px; border-color: rgb(16, 151, 16)" name="address_line_1"
                      #address_line_1="ngModel" [(ngModel)]="this.patient.address_line_1" #address1="ngModel" required
                      class="form-check-input" />
                    <div class="invalid" *ngIf="this.membershipFormChecker.address_line_1 == false">
                      Address is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.address_line_1 == true">
                      <div *ngIf="
                          address1.invalid &&
                          (address1.dirty || address1.touched)
                        " class="alert alert-danger">
                        <div *ngIf="address1.errors.required" class="invalid">
                          Address is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="add2">Address 2<span class="req"></span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="add2" type="text" pInputText [pKeyFilter]="address" style="width: 260px"
                      name="address_line_2" #address_line_2="ngModel" [(ngModel)]="this.patient.address_line_2"
                      class="form-check-input" />
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="drpDownCountry">Country<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <p-dropdown id="drpDownCountry" [options]="countries" [filter]="true" [(ngModel)]="selectedCountry"
                      optionLabel="country_name" name="country" placeholder="Select"
                      [style]="{ color: 'black', opacity: 'inherit' }" (onChange)="changeStates()" #country="ngModel"
                      [disabled]="!agree" required>
                    </p-dropdown>
                    <div class="invalid" *ngIf="this.membershipFormChecker.country_id == false">
                      Country is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.country_id == true">
                      <div *ngIf="
                          country.invalid && (country.dirty || country.touched)
                        " class="alert alert-danger">
                        <div *ngIf="country.errors.required" class="invalid">
                          Country is required.
                        </div>
                        <div *ngIf="country.errors.FieldValidator">
                          <!-- Field Validator Error -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-12 ui-md-4">
                    <label for="state">State<span class="req">*</span></label>
                  </div>
                  <ng-container *ngIf="!this.statesInput">
                    <div class="ui-g-12 ui-md-8">
                      <p-dropdown id="state" [options]="states" [(ngModel)]="selectedState" optionLabel="name"
                        placeholder="Select" name="state" #state="ngModel" required (onChange)="dirty()"></p-dropdown>
                      <div class="invalid" *ngIf="
                          this.membershipFormChecker.state_name == false ||
                          this.membershipFormChecker.state_id == false
                        ">
                        State is required.
                      </div>
                      <div *ngIf="
                          this.membershipFormChecker.state_name == true ||
                          this.membershipFormChecker.state_id == true
                        ">
                        <div *ngIf="
                            state.invalid && (state.dirty || state.touched)
                          " class="alert alert-danger">
                          <div *ngIf="state.errors.required" class="invalid">
                            State is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="this.statesInput">
                    <div class="ui-g-12 ui-md-8">
                      <input id="state" type="text" [(ngModel)]="selectedState" pInputText style="width: 260px"
                        name="state" #state="ngModel" [disabled]="this.statesInputDisabled" class="form-check-input" />
                    </div>
                  </ng-container>

                  <div class="ui-g-12 ui-md-4">
                    <label for="city">City<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="city" type="text" pInputText [pKeyFilter]="city_input"
                      style="width: 260px; border-color: rgb(16, 151, 16)" name="city" [(ngModel)]="this.patient.city"
                      #city="ngModel" required class="form-check-input" />
                    <div class="invalid" *ngIf="this.membershipFormChecker.city == false">
                      City is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.city == true">
                      <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
                        <div *ngIf="city.errors.required" class="invalid">
                          City is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="zip">Zip<span class="req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="zip" type="text" pInputText [pKeyFilter]="zipCode"
                      style="width: 260px; border-color: rgb(16, 151, 16)" name="zip"
                      [(ngModel)]="this.patient.zip_code" #zip="ngModel" required class="form-check-input" />
                    <div class="invalid" *ngIf="this.membershipFormChecker.zip_code == false">
                      Zip Code is required.
                    </div>
                    <div *ngIf="this.membershipFormChecker.zip_code == true">
                      <div *ngIf="zip.invalid && (zip.dirty || zip.touched)" class="alert alert-danger">
                        <div *ngIf="zip.errors.required" class="invalid">
                          Zip Code is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <label for="zip">Photo</label>
                  </div>
                  <div class="ui-g-12">
                    <p-fileUpload name="demo[]" (onRemove)="resetUpload()" [showCancelButton]="false"
                      (onSelect)="uploadFiles($event.files)" [showUploadButton]="false"
                      styleClass="p-fileUpload-label-fix" [maxFileSize]="5033165" multiple="false" [fileLimit]="1"
                      accept="image/*">
                    </p-fileUpload>
                    <div class="alert alert-danger" role="alert">
                      <p class="text-center text-gray-underline">
                        <span class="font-weight-bold">Note</span>: The file
                        type supported for Photo are JPEG,JPG,PNG.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="card no-margin">
          <p-fieldset [style]="{ border: '1px solid #000000' }">
            <p-header><b>Contact Information</b></p-header>
            <div class="ui-g">
              <div class="ui-g form-group">
                <div class="ui-g-12 ui-lg-5">
                  <div class="ui-g-12 ui-md-4">
                    <label for="primarycontact">Primary No.<span class="req">*</span></label>
                  </div>

                  <div class="ui-g-3 ui-md-2">
                    <input id="primarycontact" type="text" pInputText style="
                        width: 55px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " name="selected_primary" #selected_primary="ngModel"
                      [(ngModel)]="this.selectedPhoneCode_primary" disabled class="form-check-input" />
                  </div>
                  <div class="ui-g-9 ui-md-4">
                    <input id="primaryphone" type="text" pInputText [pKeyFilter]="phoneNumber" maxlength="20"
                      [(ngModel)]="primary_contact_number" name="primaryno" style="
                        width: 155px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " (keypress)="omit_special_char($event)" #primaryno="ngModel" required
                      class="form-check-input" />
                    <div class="invalid" *ngIf="
                        this.membershipFormChecker.primary_contact_number ==
                        false
                      ">
                      Primary Phone is required.
                    </div>
                    <div *ngIf="
                        this.membershipFormChecker.primary_contact_number ==
                        true
                      ">
                      <div *ngIf="
                          primaryno.invalid &&
                          (primaryno.dirty || primaryno.touched)
                        ">
                        <div *ngIf="primaryno.errors.required" class="invalid">
                          Primary Phone is required.
                        </div>
                      </div>
                    </div>
                    <!-- <div *ngIf="(primaryno.dirty || primaryno.touched)">
                                            <div class="invalid" *ngIf="primary_contact_number?.length!=10">
                                                Phone number should be of 10 digits
                                            </div>
                                        </div> -->
                  </div>
                </div>
                <div class="ui-g-12 ui-md-2"></div>
                <div class="ui-g-12 ui-lg-5">
                  <div class="ui-g-12 ui-md-4">
                    <label for="secondarycontact">Secondary No.</label>
                  </div>
                  <div class="ui-g-3 ui-md-2">
                    <input id="secondarycontact" type="text" pInputText style="
                        width: 55px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " name="selected_secondary" #selected_secondary="ngModel"
                      [(ngModel)]="this.selectedPhoneCode_secondary" disabled class="form-check-input" />
                  </div>
                  <div class="ui-g-9 ui-md-4">
                    <input id="secondaryphone" type="text" pInputText [pKeyFilter]="phoneNumber" maxlength="20"
                      [(ngModel)]="secondary_contact_number" name="secondaryno" style="
                        width: 155px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " (keypress)="omit_special_char($event)" #secondaryno="ngModel" class="form-check-input" />
                    <!-- <div
                                            *ngIf="(secondaryno.dirty || secondaryno.touched) && secondary_contact_number?.length>0">
                                            <div class="invalid" *ngIf="secondary_contact_number?.length!=10">
                                                Phone number should be of 10 digits
                                            </div>
                                        </div> -->
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>

      <div class="ui-g-12" style="text-align-last: right">
        <button pButton type="button" label="Cancel" style="
            margin-bottom: 10px;
            margin-right: 5px;
            background: #c02929;
            color: #ffffff;
            border-color: #c02929;
          " [routerLink]="['/', this.slug, 'patient']"></button>
        <button pButton type="submit" [disabled]="
            !membershipform.valid ||
            primary_contact_number.length != 10 ||
            (secondary_contact_number.length > 0 &&
              secondary_contact_number.length != 10) ||
            selectedPhoneCode_primary == '' ||
            this.api_result.Posting
          " label="Submit" style="margin-bottom: 10px; margin-right: 5px" class="p-button-lg"></button>
      </div>

      <div class="ui-g-12">
        <app-error-messages [api_result]="this.api_result"></app-error-messages>
      </div>
    </form>
  </ng-container>
  <!-- </form> -->
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" *ngIf="this.api_result.Posting" strokeWidth="6">
  </p-progressSpinner>
</div>

<div class="container text-center" *ngIf="view_payment == true">
  <!-- <h5>Amount to be paid for Membership {{amount | currency:currency}}</h5> -->
  <div class="spaces"></div>
  <!-- <ngx-paypal [config]="payPalConfig"></ngx-paypal> -->
  <button pButton name="back" label="Go back" type="button" class="p-button-secondary"
    (click)="view_payment = false"></button>
  <ng-container>
    <div class="ui-g-12">
      <div class="card no-margin">
        <p-fieldset [style]="{ border: '1px solid #000000' }">
          <p-header><b>Membership Payment Information</b></p-header>
          <div class="ui-g" style="text-align: center">
            <div class="ui-g-12 ui-md-6 justify-content-center text-center">
              <div class="row justify-content-center">
                <div class="container">
                  <div class="row">
                    <div
                      class="receipt-main col-xs-10 col-sm-10 col-md-6 col-xs-offset-1 col-sm-offset-1 col-md-offset-3">
                      <div class="row">
                        <div class="receipt-header">
                          <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="receipt-left">
                              <img class="img-responsive" alt="iamgurdeeposahan" [src]="this.logo_url"
                                style="height: 90px; border-radius: 0px" />
                            </div>
                          </div>

                          <div class="col-xs-6 col-sm-6 col-md-6 text-right">
                            <div class="receipt-right">
                              <h2>12 months of Membership</h2>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="receipt-header receipt-header-mid">
                          <div class="col-xs-4 col-sm-4 col-md-4">
                            <div class="receipt-center">
                              <h1>Payment Invoice</h1>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="receipt-details">
                        <table class="table table-bordered" id="pdfcontent">
                          <thead>
                            <tr>
                              <th>Description</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of basket.item_list">
                              <td class="col-md-9">{{ item.name }}</td>
                              <td class="col-md-3 notranslate">
                                {{ item.raw_amount | currency: currency }}
                              </td>
                            </tr>

                            <tr>
                              <td class="text-right">
                                <h2><strong>Total: </strong></h2>
                              </td>
                              <td class="text-left notranslate" style="color: #004aad !important">
                                <h2>
                                  <strong>{{
                                    basket.raw_total | currency: currency
                                    }}</strong>
                                </h2>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 text-center">
              <div class="ui-g-12 ui-md-8">
                <h2 id="heading" class="text-center">Payment Information</h2>
                <div id="dropin-mod" *ngIf="is_paypal != null && is_paypal">
                  <div id="dropin-container"></div>
                  <button pButton *ngIf="is_paypal != null && is_paypal" name="submit" label="Pay" type="submit"
                    class="p-button-secondary" (click)="pay()"></button>
                </div>
                <div *ngIf="is_paypal != null && !is_paypal">
                  <button pButton name="submit" label="Pay by Razorpay" type="submit" class="p-button-secondary"
                    (click)="paybyrazor()"></button>
                </div>
                <div *ngIf="is_paypal != null && is_paypal">
                  <p *ngIf="nopaymentselected == true"
                    class="row container justify-content-center text-center alert alert-danger">
                    Please Select a Payment Method
                  </p>
                </div>
                <div>
                  {{ basket.disclaimer }}
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </ng-container>

  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-12 col-lg-11 col-xl-10">
        <div class="card card0">
          <div class="row">
            <div class="col-md-6 d-block p-0 box"></div>
            <div class="col-md-6 col-sm-12 p-0 box"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container text-center" *ngIf="success != null && success == true && final_result == true">
  <p-dialog header="Welcome User" [closable]="false" [(visible)]="display1"
    [style]="{ width: '50vw', 'text-align': 'center' }" [baseZIndex]="10000">
    <p>
      Thanks for becoming a member of eGlobalDoctors.<b>
        Here is the Medical Record Number(MRN): {{ medical_record_number }}</b>
      for the patient {{ patient.first_name + ' ' + patient.last_name }}. Please
      save this for future reference.
    </p>
    <p>Click here for next steps</p>
    <p-button label="Go to Dashboard" [style]="{ 'margin-right': '10px' }"
      [routerLink]="['../../', 'dashboard']"></p-button>
  </p-dialog>
</div>